// test2692
(2692 && 0);
